export const getAge = dob => {
  const date_of_birth = new Date(dob);
  const diff_ms = Date.now() - date_of_birth.getTime();
  const age_dt = new Date(diff_ms);

  return Math.abs(age_dt.getUTCFullYear() - 1970);
};
